// extracted by mini-css-extract-plugin
export default {"container":"RDhNTujsaTg8ag0S8auq","picture":"CI6BiqCc1qyvDI34eCLw","text":"xhndiJbw0tIuO3Lg1deM","link":"qH9J7ZSHvPrEEp4cAxWg"};